"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrongCountryIdException = void 0;
const http_exception_1 = require("../http.exception");
class WrongCountryIdException extends http_exception_1.HttpException {
    constructor(country) {
        super(501, `Unknown country id: ${country}`);
    }
}
exports.WrongCountryIdException = WrongCountryIdException;
//# sourceMappingURL=wrongCountryId.exception.js.map